import { Enums, Events } from "../../thor.enums";
import { OnlineItemModificationCounts, OrderCounts } from "../../typings/sale";
import { isAdvertiser } from "../../utils/organization";

export class OnlineSummaryController {
    public static $inject: string[] = [
        "$scope",
        "$mdDialog",
        "$mdMedia",
        "$rootScope",
        "$translate",
        "onlinePriceService",
        "toaster"
    ];

    public isFirstPublication: boolean;
    public isContainerEdited: boolean;
    public itemModificationCounters: OnlineItemModificationCounts;
    public publishing: boolean;
    public secretsOrdersCounters: OrderCounts;

    private container: any; // bind from parent (OnlineContainerEditController::initiatePublish)
    private $t: Function;

    constructor(
        $scope,
        public $mdDialog,
        public $mdMedia,
        private $rootScope: ng.IRootScopeService,
        $translate: ng.translate.ITranslateService,
        public onlinePrice,
        private toaster
    ) {
        $scope.isAdvertiser = () => isAdvertiser(this.container.authService.organization);
        this.$t = $translate.instant;
        this.setUp();
    }

    public publishContainer() {
        this.publishing = true;
        this.container
            .publishSale()
            .then(() => {
                this.$rootScope.$broadcast(Events.PostMessageToV2);
                this.toaster.show(this.$t("publication_effectuee_avec_succes"));
            })
            .catch(() => this.toaster.show(this.$t("la_publication_a_echoue"), true))
            .finally(() => this.$mdDialog.hide());
    }

    public filterItems(elem) {
        return elem.status !== Enums.ItemStatus.Confirmed;
    }

    private setCounters() {
        this.itemModificationCounters = {
            newItems: 0,
            modifiedItems: 0,
            suppressedItems: 0,
            publishedItems: 0
        };
        this.secretsOrdersCounters = {
            modified: 0,
            suppressed: 0
        };
    }

    private setUp() {
        this.publishing = false;
        this.isFirstPublication = this.container.resource.status === Enums.SaleStatus.Created;
        this.isContainerEdited = this.container.resource.status === Enums.SaleStatus.Edited;

        this.setCounters();

        this.container.items.forEach(item => {
            if (item.states.suppressed) {
                this.itemModificationCounters.suppressedItems++;
            } else {
                if (item.status === Enums.ItemStatus.Created) {
                    this.itemModificationCounters.newItems++;
                } else if (item.status === Enums.ItemStatus.Modified) {
                    this.itemModificationCounters.modifiedItems++;
                }
                this.itemModificationCounters.publishedItems++;
            }
        });
    }
}
